import type { Theme } from '@mui/material';

export const muiInputLabelOverrides = {
	styleOverrides: {
		root: ({ theme }: { theme: Theme }) => {
			return {
				position: 'static',
				transform: 'none',
				textTransform: globalThis.cardProvider.IS_HSBC_PROVIDER_SETUP ? 'none' : 'uppercase',
				fontWeight: globalThis.cardProvider.IS_HSBC_PROVIDER_SETUP
					? theme.typography.tsFontWeight.bolder
					: theme.typography.tsFontWeight.bold,
				fontSize: theme.typography.pxToRem(theme.typography.tsFontSize.mini),
				whiteSpace: 'nowrap',
				wordWrap: 'normal',
				overflow: 'hidden',
				textOverflow: 'ellipsis',
				color: theme.palette.common.black,
				paddingBottom: theme.tsGoUnit.tsUnitHalf,
			};
		},
	},
};
